import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// Response 타입 (shoebill.ts에서 가져온 raw DTO)
type FrequentlyOrderProductListResponse =
  OAISchema['MarketSelectProductResponseV2'][];

export interface FrequentlyOrderDataSource {
  // Query
  getFrequentlyOrderProducts(): Promise<FrequentlyOrderProductListResponse>;
}

export class FrequentlyOrderDataSourceImpl
  implements FrequentlyOrderDataSource
{
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getFrequentlyOrderProducts() {
    return this.client.request<FrequentlyOrderProductListResponse>({
      url: '/api/market-place/v1/frequently-order/products',
      method: 'get',
    });
  }
}

export const frequentlyOrderDataSource = new FrequentlyOrderDataSourceImpl();
